var path = '/components/toggle-button/toggle-button.template.html';
var html = "<div class=toggle-button ng-class=\"{ 'toggle-button-selected': selected, 'disabled': disabled }\"> <button type=button></button> </div> ";
window.angular.module('citifydMonitoring').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;